import { EpDetail } from '@bumble/app/__generated__/data-contracts';
import { Indicator } from '@bumble/app/components/Indicator';
import NoData from '@bumble/app/components/NoData';
import { TabGrid, TabGridStructure } from '@bumble/app/components/TabGrid';
import { theme } from '@bumble/app/theme';
import getDate from '@bumble/app/utils/get-date';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';

const accordionStyles = {
  boxShadow: 'none',
  '&::before': {
    display: 'none',
  },
};

const accordionSummaryStyles = {
  flexDirection: 'row-reverse',
  fontWeight: 700,
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(-90deg)',
    color: theme.palette.primary.main,
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)'
  },
}

export const EndpointTabDetails = ({ data }: { data: EpDetail | undefined }) => {
  if (data === undefined) return <NoData />;

  const tabDataGeneral: TabGridStructure[] = [
    { label: 'Endpoint Name', content: data?.ep_name || 'N/A' },
    { label: 'Created at', content: data !== undefined && data?.created_at ? getDate(data?.created_at) : 'N/A' },
    { label: 'Description', content: data?.description || 'N/A' },
    { label: 'Admin State', content: data?.admin_state || 'N/A' },
    { label: 'Admin State Change at', content: data !== undefined && data?.admin_state_change_at ? getDate(data?.admin_state_change_at) : 'N/A' },
    { label: 'OP State', content: data?.op_state !== undefined ? <Indicator active={data?.op_state === 'up'} /> : 'N/A' },
    { label: 'OP State Change at', content: data !== undefined && data?.op_state_change_at ? getDate(data?.op_state_change_at) : 'N/A' },
    { label: 'Account Id', content: data?.account_id || 'N/A' },
    { label: 'Endpoint Id', content: data?.ep_id || 'N/A' },
    { label: 'IP Address', content: data?.ip_addr || 'N/A' },
    { label: 'App DNS Name', content: data?.fqdn || 'N/A' },
    { label: 'AppService ID', content: data?.app_service_id || 'N/A' },
  ];

  const tabDataAws: TabGridStructure[] = [
    { label: 'Region', content: data?.region || 'N/A' },
    { label: 'Allowed Principle', content: data?.consumer_principle || 'N/A' },
  ];

  const tabDataNet: TabGridStructure[] = [
    { label: 'Network Mode Enabled', content: data?.network_mode_enabled !== undefined && (data?.network_mode_enabled == true) ? 'yes' : 'no' },
    { label: 'Address Translation Enabled', content: data?.address_translation_enabled !== undefined && (data?.address_translation_enabled == true) ? 'yes' : 'no' },
    { label: 'BGP Enabled', content: data?.bgp_enabled != undefined && (data?.bgp_enabled == true) ? 'yes' : 'no' },
    { label: 'BGP Local ASN', content: data?.bgp_local_asn?.toString() || 'N/A' },
    { label: 'BGP Peer ASN', content: data?.bgp_peer_asn?.toString() || 'N/A' },
    { label: 'BGP Local IP', content: data?.bgp_local_ip || 'N/A' },
    { label: 'BGP Peer IP', content: data?.bgp_peer_ip || 'N/A' },
    { label: 'Real Subnet', content: data?.real_subnets || 'N/A' },
    { label: 'Virtual Subnet', content: data?.virtual_subnets || 'N/A' },
  ];

  const tabDataContacts: TabGridStructure[] = [
    { label: 'Endpoint Primary Contact', content: data?.ep_primary_contact || 'N/A' },
    { label: 'Endpoint Secondary Contact', content: data?.ep_secondary_contact || 'N/A' },
    { label: 'AppService Primary Contact', content: data?.app_service_primary_contact || 'N/A' },
    { label: 'AppService Secondary Contact', content: data?.app_service_secondary_contact || 'N/A' },
  ];

  const getSpecificTabData = () => {
    let tabDataSpecific: TabGridStructure[] = [{ label: 'Deployment', content: data?.deployment || 'N/A' }];
    if (data?.deployment == 'aws') {
      tabDataSpecific = tabDataSpecific.concat(tabDataAws);
    }
    if (data?.network_mode_enabled) {
      tabDataSpecific = tabDataSpecific.concat(tabDataNet);
    }
    return <TabGrid data={tabDataSpecific} />;
  };
  return (
    <Box>
      <Accordion sx={accordionStyles}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={accordionSummaryStyles}
        >
          General
        </AccordionSummary>
        <AccordionDetails>
          <TabGrid data={tabDataGeneral} />
        </AccordionDetails>
      </Accordion>
      {data?.deployment === 'onprem' && !!data?.network_mode_enabled && (
        <Accordion sx={accordionStyles}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={accordionSummaryStyles}
          >
            Specific
          </AccordionSummary>
          <AccordionDetails>
            {getSpecificTabData()}
          </AccordionDetails>
        </Accordion>
      )}
      <Accordion sx={accordionStyles}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={accordionSummaryStyles}
        >
          Contacts
        </AccordionSummary>
        <AccordionDetails>
          <TabGrid data={tabDataContacts} colWidth={6} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
